var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSymbolLoginTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 172,
    viewBox: "0 0 105 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2246_4632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.498 44.6035C73.1274 44.6035 48.3692 63.3474 48.3691 86.3008V172H24.3135V86.3008C24.3136 50.0164 59.7964 20.5479 103.498 20.5479V44.6035ZM103.498 4.00977C79.1414 4.00977 55.8868 11.8271 38.1455 25.96C18.9007 41.4961 7.77543 63.4476 7.77539 86.3008H3.76562C3.76566 62.2449 15.3927 39.0913 35.6396 22.8535C54.0826 8.11922 78.2393 0 103.498 0V4.00977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9623 101.737C97.0963 101.737 104.501 94.3326 104.501 85.1987C104.501 76.0647 97.0963 68.6602 87.9623 68.6602C78.8284 68.6602 71.4238 76.0647 71.4238 85.1987C71.4238 94.3326 78.8284 101.737 87.9623 101.737Z",
    fill: "#85F2A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2246_4632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 172,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSymbolLoginTablet);
export default __webpack_public_path__ + "static/media/ic_symbol_login_tablet.c84be60cf24220460755a1ff8d962aa1.svg";
export { ForwardRef as ReactComponent };